import { DashboardDescription } from '@modules/dashboard/components/DashboardDescription';
import { DashboardEmoji } from '@modules/dashboard/components/DashboardDetails/DashboardEmoji';
import { DashboardName } from '@modules/dashboard/components/DashboardName';
import { useDashboardStore } from '@modules/dashboard/store/useDashboardStore';
import CloseRounded from '@mui/icons-material/CloseRounded';
import { Button, Stack } from '@mui/material';
import { useSearchParams } from 'react-router-dom';

export function DasboardHeaderInTVMode() {
  const dashboard = useDashboardStore(({ dashboard }) => dashboard);
  const [searchParams, setSearchParams] = useSearchParams();

  const exitTVMode = () => {
    searchParams.delete('tv');
    setSearchParams(searchParams);
  };

  if (!dashboard) {
    return null;
  }

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Stack>
        <Stack direction="row" alignItems="center" spacing={1}>
          <DashboardEmoji dashboard={dashboard} />
          <DashboardName name={dashboard.title} isReadOnly={true} />
        </Stack>
        <DashboardDescription
          dashboard={dashboard}
          shouldShowFullDescription={true}
        />
      </Stack>
      <Stack direction="row" spacing={1}>
        <Button
          size="small"
          variant="outlined"
          onClick={exitTVMode}
          startIcon={<CloseRounded />}
        >
          Exit TV Mode
        </Button>
      </Stack>
    </Stack>
  );
}
